import React, { FC } from "react";
import { RadioButtonUnchecked } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";

const KeieiShindanManagerAnalysisOKButton: FC<{
  id: string;
  bigItemId: string;
  smallItemId: string;
}> = ({ id, bigItemId, smallItemId }) => {
  return (
    <IconButton>
      <RadioButtonUnchecked style={{ fontSize: "16px" }} />
    </IconButton>
  );
};
export default KeieiShindanManagerAnalysisOKButton;
